<template>
	<div>
		<el-dialog top="50px" v-if="pay_status==0" :visible.sync="dialogVisible" width="882px"
			custom-class="openvip-dialog" @close="handleClose" :show-close="false" center :close-on-click-modal="false"
			destroy-on-close>
			<div class="openvip-box">
				<div class="closebtn cur" @click="dialogVisible=false">
					<i class="el-icon-close"></i>
				</div>
				<div class="title">开通会员</div>
				<div class="pd">
					<ul class="vlist between">
						<li class="cur" :class="type_index==k?'on':''" @click="onvipstatus(k,v)" v-for="v,k in list"
							:key="v.type_id">
							<div class="vbox align-c between">
								<div class="k">
									<div class="t">{{v.level_name}}</div>
									<div class="t2">￥<b>{{v.money}}</b>/年</div>
								</div>
								<!-- <img src="@/static/vip-pic1.png" class="p" /> -->

								<img v-if="v.type_id==2" class="p" src="@/static/vip-pic1.png">
								<img v-if="v.type_id==3" class="p" src="@/static/vip-pic3.png">
								<img v-if="v.type_id==4" class="p" src="@/static/vip-pic2.png">

							</div>
							<div class="tit vcenter">可备案作品数量为 {{v.goods_num}}/年</div>
						</li>

						<li class="blank"></li>
						<li class="blank"></li>
					</ul>

					<div class="title2">支付方式：</div>
					<ul class="payment-tab between">
						<li class="vcenter cur" :class="payment_tab==1?'on':''" @click="ontab(1)">
							微信支付
							<img src="@/static/z-icon-checked.png" class="checked">
						</li>
						<li class="vcenter cur" :class="payment_tab==2?'on':''" @click="ontab(2)">
							支付宝支付
							<img src="@/static/z-icon-checked.png" class="checked">
						</li>
						<li class="vcenter cur" :class="payment_tab==3?'on':''" @click="ontab(3)">
							对公转账
							<img src="@/static/z-icon-checked.png" class="checked">
						</li>
					</ul>
					<div class="paymentbox" v-show="payment_tab==1 || payment_tab==2">
						<!-- <div class="paytype align-c">
							<div v-for="v,k in pay_list" :key="v.pay_id" class="btn" @click="onpaytype(v.pay_id)"
								:class="paytype==v.pay_id?'on':'cur curadm'">{{v.name}}</div>
						</div> -->
						<!-- 微信 -->
						<div class="payment_box" v-show="payment_tab==1">
							<div class="qrcodebox">
								<div class="qrimg">
									<!-- 微信支付二维码 -->
									<img v-if="wechartpayinfo.qrcode" :src="'data:image/png;base64,'+wechartpayinfo.qrcode" class="p cur" @click="order_creat()" title="点击刷新" />
									<div class="loading vcenter" v-if="qrcode_loading">
										<div class="align-c">
											<i class="el-icon-loading"></i>加载中...
										</div>
									</div>
									<div class="ts vcenter" v-if="!checked">
										<div class="t">请先阅读并同意相关协议再扫码支付 </div>
										<div class="btn vcenter cur curadm" @click="checked=true">确认同意</div>
									</div>
								</div>
								<div class="tit vcenter">
									<div class="align-c"><img src="@/static/z-icon-wx2.png" class="icon" /> 请使用微信支付
									</div>
								</div>
							</div>
							<div class="parsebox">
								<div class="t">同意并支付：<span class="red">￥<b>{{money}}</b></span></div>
								<div class="policy"><el-checkbox v-model="checked">我已阅读并同意 <span class="cur curadm"
											@click.stop.prevent="text()">《会员协议》</span><span class="cur curadm"
											@click.stop.prevent="text()">《付费授权协议》</span></el-checkbox></div>
							</div>
						</div>
						<!-- 支付宝 -->
						<div class="payment_box" v-show="payment_tab==2">
							<div class="qrcodebox">
								<div class="qrimg">
									<!-- <img src="@/static/test-qrcode.png" class="p"/> -->
									<!-- <div class="p" @click="submitAlipayForm">
										点击支付
									</div> -->
									<div class="ref-btn cur" @click="order_creat()" title="点击刷新"></div>
									<iframe
										v-if="alipaypayinfo.form && dialogVisible"
										:srcdoc="alipaypayinfo.form" 
										class="p"
										frameborder="no" 
										border="0"
										marginwidth="0" 
										marginheight="0" 
										scrolling="no" 
										style="overflow: hidden;">
									</iframe>
									<div class="loading vcenter" v-if="qrcode_loading">
										<div class="align-c">
											<i class="el-icon-loading"></i>加载中...
										</div>
									</div>
									<div class="ts vcenter" v-if="!checked">
										<div class="t">请先阅读并同意相关协议再扫码支付 </div>
										<div class="btn vcenter cur curadm" @click="checked=true">确认同意</div>
									</div>
								</div>
								<div class="tit vcenter">
									<div class="align-c"><img src="@/static/z-icon-zfb.png" class="icon" /> 请使用支付宝支付
									</div>
								</div>
							</div>
							<div class="parsebox">
								<div class="t">同意并支付：<span class="red">￥<b>{{money}}</b></span></div>
								<div class="policy"><el-checkbox v-model="checked">我已阅读并同意 <span class="cur curadm"
											@click.stop.prevent="text()">《会员协议》</span><span class="cur curadm"
											@click.stop.prevent="text()">《付费授权协议》</span></el-checkbox></div>
							</div>
						</div>
					</div>
					<div class="paymentbox" v-show="payment_tab==3">
						<div class="payment_box2">
							<div class="tsbox">请通过对公账号向环太湖艺术城…公司完成以下汇款，汇款完成后请联系我公司财务人员进行核对，财务电话：0519-8865475</div>
							<div class="title3">请向以下账户汇入指定金额：</div>
							<ul class="info">
								<li>
									<div class="lab">付款金额：</div>
									<div class="val"><span class="red">￥<b>{{money}}</b></span></div>
								</li>
								<li>
									<div class="lab">收款账号：</div>
									<div class="val">
										<div class="num align-c">6233 0154 5855 5867 74 <div class="btn cur curadm"
												@click="copyText('6233  0154  5855  5867 74')">复制</div>
										</div>
										<div class="ts">请勿重复付款</div>
									</div>
								</li>
								<li>
									<div class="lab">开户银行：</div>
									<div class="val">中国建设银行常州支行</div>
								</li>
								<li>
									<div class="lab">收款公司名：</div>
									<div class="val">环太湖艺术城…公司</div>
								</li>
							</ul>
						</div>
					</div>

				</div>
			</div>
		</el-dialog>

		<el-dialog append-to-body v-if="pay_status==1" :visible.sync="dialogVisible" width="500px"
			custom-class="payok-dialog" @close="handleClose" :show-close="false" center>
			<div class="pay_ok">
				<div class="closebtn cur" @click="dialogVisible=false">
					<i class="el-icon-close"></i>
				</div>
				<div class="vcenter">
					<i class="el-icon-success okicon"></i>
					<div class="text">支付成功</div>
				</div>



			</div>
		</el-dialog>
		<agreement ref="agreement" @agree="agree"></agreement>
	</div>

</template>

<script>
	var setinv;
	import ty from "@/utils/ty/ty"
	import util from "@/common/util.js"
	import agreement from "@/components/agreement/agreement"
	export default {
		name: 'openVip',
		components:{
			agreement
		},
		props: {
			// 外部参数示例
			// data: {
			//     type: Array,
			//     default: () => []
			// },
		},
		data() {
			return {
				paytype: 1,
				dialogVisible: false,
				type_index: 0,
				type_id: 1,
				payment_tab: 1,
				money: 0,
				checked: false,
				list: [],
				pay_list: [],
				wechartpayinfo: {},
				alipaypayinfo: {},
				order_id: null,
				pay_status: 0,
				qrcode_loading:false,
			}
		},
		watch: {
			dialogVisible(v) {
				if (this.pay_status == 0) {
					if (v) {
						clearInterval(setinv)
						setinv = setInterval(() => {
							this.getpaystatus()
						}, 2000)
					} else {
						clearInterval(setinv)
					}
				}
			}
		},

		methods: {
			getlist(callback) {
				ty.ajax("web/order/order/initpay", {}).then((d) => {
					this.list = d.data.type_list
					this.pay_list = d.data.pay_list
					if (this.list.length > 0 && this.type_index == 0) {
						this.money = this.list[0].money
					}
					this.order_creat()
				})
			},
			submitAlipayForm() {
				// 假设你已经通过 API 获取到了支付宝返回的 form 字符串
				if (this.alipaypayinfo.form){
					const formHtml = this.alipaypayinfo.form
					
					// 创建一个临时 div 来解析 HTML
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = formHtml.trim();
					
					// 获取表单元素
					const form = tempDiv.querySelector('form');
					
					if (form) {
						// 设置表单 target（可选：在当前页跳转，或新窗口）
						form.target = '_self'; // 或 '_blank'
					
						// 将表单添加到 body
						document.body.appendChild(form);
					
						// 提交表单
						form.submit();
					
						// 可选：提交后移除表单
						document.body.removeChild(form);
					} else {
						console.error('未找到支付宝表单');
					}
				}
				else{
					console.log("支付错误")
				}
				
			},
			getpaystatus() {
				if (this.payment_tab==1 || this.payment_tab==2){
					if (this.order_id){
						ty.ajax("web/order/order/detail",{
							id:this.order_id
						}).then((d)=>{
							this.pay_status = d.data.pay_status
							if (this.pay_status==1){
								clearInterval(setinv)
							}
						})
					}
				}
				
			},

			// order_creat_init(){
			// 	var v = this.list[this.type_index]
			// 	ty.ajax("web/order/order/create",{
			// 		type_id:v.type_id,
			// 		pay_id:this.paytype,
			// 		return_url:"http://192.168.0.78:8080/#/userCenter/vipService"
			// 	}).then((d)=>{


			// 	}).catch(()=>{

			// 	})
			// },


			order_creat(callback) {
				var v = this.list[this.type_index]
				this.qrcode_loading = true
				ty.ajax("web/order/order/create", {
					type_id: v.type_id,
					pay_id: this.payment_tab,
					return_url: "http://192.168.0.78:8080/#/userCenter/vipService"
				}).then((d) => {
					if (this.payment_tab == 1) {
						this.wechartpayinfo = {}
						this.wechartpayinfo = d.data
						this.qrcode_loading = false
					} else if (this.payment_tab == 2) {
						this.alipaypayinfo = {}
						this.alipaypayinfo = d.data
						setTimeout(()=>{
							this.qrcode_loading = false
						},700)
					}
					this.order_id = d.data.order_id
					if (callback) {
						callback()
					}
					
					//this.order_detail(d.data.order_id)
				}).catch(() => {
					this.qrcode_loading = false
				})
			},

			handleClose() {
				
			},
			openvip(n, v) {
				console.log("n",n)
				this.pay_status = 0
				this.dialogVisible = true
				this.getlist()
				if (v) {
					this.money = v.money
				}
				if (typeof n !== 'undefined') {
				  if (this.type_index != n) {
				  	this.type_index = n
				  }
				}

			},
			onvipstatus(n, v) {
				this.money = v.money
				if (this.type_index != n) {
					this.type_index = n
					//this.checked = false
					this.order_creat()
				}
			},
			ontab(n) {
				if (this.payment_tab != n) {
					this.payment_tab = n
					if (n==1 || n==2){
						this.order_id=0
						this.order_creat()
					}
				}

			},
			onpaytype(pay_id) {
				if (this.paytype != pay_id) {
					this.paytype = pay_id
					this.order_id=0
					this.order_creat()
					
				}
			},
			text() {
				this.$refs.agreement.dialogVisible = true
			},
			agree(){
				this.checked = true
			},
			async copyText(t) {
				try {
					await navigator.clipboard.writeText(t);
					util.vmsg('复制成功！'); // 如果你用了 Element UI
					// 或者用 alert
					// alert('复制成功！');
				} catch (err) {
					console.error('复制失败:', err);
					alert('复制失败，请手动复制');
				}
			}
		},
		mounted() {

		}

	}
</script>

<style lang="scss">
	@import "openVip.scss";
</style>